import React from 'react'
import styled from 'styled-components'
import { Loader } from '@elparking/components'

const Container = styled.div`
    display: block;
    padding: 50px;
    text-align: center;
`
const MapLoader = () =>
    <Container>
        <Loader size='30px' color='mainColor' />
    </Container>

export default MapLoader
